import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const BASE_PATH = "/api/agent/site-destinations";

function resolvePath(path = "") {
  return resolveApiUrl(`${BASE_PATH}${path}`);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("agent_site_destinations_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 30000,
    sid,
  };
}

export async function fetchAgentSiteDestinations() {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.get(resolvePath(""), cfg);
  return Array.isArray(data?.items) ? data.items : [];
}

export async function createAgentSiteDestination(payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.post(resolvePath(""), { ...payload, sessionID: cfg.sid }, cfg);
  return data;
}

export async function updateAgentSiteDestination(id, payload) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.put(resolvePath(`/${id}`), { ...payload, sessionID: cfg.sid }, cfg);
  return data;
}

export async function deleteAgentSiteDestination(id) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.delete(resolvePath(`/${id}`), cfg);
  return data;
}

export async function toggleAgentSiteDestination(id, field) {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.patch(resolvePath(`/${id}/toggle`), { field, sessionID: cfg.sid }, cfg);
  return data;
}
